import { LayoutConst } from "core";
import styled from "styled-components";
import { css } from "styled-components";

export const BookmarkButtonWrapper = styled.div<{
    isProjectPage?: boolean
    type?: boolean
    mobilePosition?: string
}>`
    z-index: 10;
    // position: absolute;
    // right: 16px;
    // top: 10px;
    padding: 4px 8px;
    background: rgba(24, 26, 28, 0.5);
    backdrop-filter: blur(2px);
    border-radius: 4px;

    @media (max-width: ${LayoutConst.screen.mac13 - 1}px) {
        padding: 4px 6px;
        height: 24px;
        width: 30px;

        svg {
            vertical-align: top;
            width: 18px;
            height: 18px;
        }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        position: ${p => p.mobilePosition || 'initial'};
        top: 8px;
        right: 8px;
        padding: 4px 6px;
        height: 24px;
        width: 30px;

        svg {
            // position: relative;
            // top: -2px;
            vertical-align: top;
            width: 16px;
            height: 16px;
        }
    }
`;
import { LayoutConst } from "core";
import styled from "styled-components";
import { css } from "styled-components";

export const BookmarkButtonWrapper = styled.div<{
    isProjectPage?: boolean
    type?: boolean
    mobilePosition?: string
}>`
    z-index: 10;
    // position: absolute;
    // right: 16px;
    // top: 10px;
    padding: 4px 8px;
    background: rgba(24, 26, 28, 0.5);
    backdrop-filter: blur(2px);
    border-radius: 4px;

    @media (max-width: ${LayoutConst.screen.mac13 - 1}px) {
        padding: 4px 6px;
        height: 24px;
        width: 30px;

        svg {
            vertical-align: top;
            width: 18px;
            height: 18px;
        }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        position: ${p => p.mobilePosition || 'initial'};
        top: 8px;
        right: 8px;
        padding: 4px 6px;
        height: 24px;
        width: 30px;

        svg {
            // position: relative;
            // top: -2px;
            vertical-align: top;
            width: 16px;
            height: 16px;
        }
    }
`;
